module.exports = __webpack_public_path__ + "img/is.2ce20c50.svg";